/* @flow */
import Collection from 'lib/Collection';
import Subscription from 'entities/Subscription';

// $FlowIssue
class Subscriptions extends Collection<Subscription> {
  initialize() {
    // $FlowIssue
    this.url = '/subscriptions';
    this.model = Subscription;
  }

  getGroupIds() {
    return this.map(subscription => subscription.getGroupId());
  }
}

export default Subscriptions;
